import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-marketplace-shopping-cart-home',
  templateUrl: './cv-marketplace-shopping-cart-home.component.html',
  styleUrls: ['./cv-marketplace-shopping-cart-home.component.scss']
})
export class CvMarketplaceShoppingCartHomeComponent implements OnInit {

  @Output() clearSearch = new EventEmitter<string>();
  pscs = null;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private cvLocalizationService: CVLocalizationService,
  ) { 
    this.pscs = shoppingCartService.shoppingCartObj;
  }

  ngOnInit(): void {
    this.pscs.shoppingCartActiveTab = 'HOME';
    this.clearSearch.emit();
  }

}
